/* global angular, swal, _ */
export default function($scope, $log, $q, CoursesClass, CategoryClass, ApiClass, $uibModalInstance, selectedEmployees) {
  'ngInject';
  $scope.resultsQueried = false;
  $q.all([
    ApiClass.coursesGet(
      { courseType: false },
      {},
      {
        queryParams: {
          internal: true,
          filters: JSON.stringify({ deliveryMethods: CoursesClass.delivery_methods, activeOnly: true, basic: true })
        }
      }
    ),
    CategoryClass.loadCategories()
  ])
    .then(([coursesResponse, categories]) => {
      const courses = coursesResponse.data.courses;
      $scope.allCourses = [];
      $scope.assigned = [];
      $scope.alreadyStarted = [];
      $scope.resultsQueried = true;
      $scope.categoryDict = categories.obj;
      $scope.allCourses = courses.filter(course => {
        if (!course.hours || !CoursesClass.isCourse(course)) return false;
        return true;
      });
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });
  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.assignEmployeesCourse = courses => {
    const selectedCourses = courses.filter(({ selected }) => selected);
    const profile_uids = selectedEmployees.map(({ profile_uid }) => profile_uid);

    if (!selectedCourses.length) {
      $scope.cancel();
      swal('Error', 'Select one or more courses', 'error');
      return;
    }

    return Promise.all(
      selectedCourses.map(course =>
        ApiClass.coursesIdTypePut(
          { id: course.course_id, type: 'assigned' },
          { profile_uids },
          { queryParams: { manage: true } }
        )
      )
    )
      .then(data => {
        swal('Assigned', 'Course(s) assigned', 'success');
        $uibModalInstance.close();
      })
      .catch(error => {
        $log.error(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/employeesCourses/index.js